import script from "./record-detail.vue?vue&type=script&lang=ts&setup=true"
export * from "./record-detail.vue?vue&type=script&lang=ts&setup=true"

import "./record-detail.vue?vue&type=style&index=0&id=b63763a8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b63763a8"]])

export default __exports__